<template>
  <div class=" mr-2"
       v-bind:class="{'checkBox': mode==='normal', 'checkbox-large':mode==='large','checkbox-medium': mode==='medium'}">
    <div
      v-bind:class="{'selected': selected,'medium':mode==='medium', 'large':mode==='large'}"></div>
  </div>
</template>

<script>
export default {
  name: "CustomCheckbox",
  props: {
    selected: {required: true, type: Boolean, default: false},
    mode: {required: false, default: 'normal'},
  }
}
</script>

<style scoped>
.checkBox {
  height: 15px;
  width: 15px;
  background-color: #EAEBEC;
  padding: 2px;
}

.selected {
  height: 11px;
  width: 11px;
  background-color: var(--primary);
}

.checkbox-large {
  height: 30px;
  width: 30px;
  background-color: #EAEBEC;
  padding: 4px;
}

.large {
  height: 22px;
  width: 22px;
}

.checkbox-medium {
  height: 20px;
  width: 20px;
  background-color: #EAEBEC;
  padding: 2px;
}

.medium {
  height: 18px;
  width: 18px;
}
</style>
